import { render, staticRenderFns } from "./OrganisationMembersTable.vue?vue&type=template&id=f8a1e5bc&scoped=true"
import script from "./OrganisationMembersTable.vue?vue&type=script&lang=js"
export * from "./OrganisationMembersTable.vue?vue&type=script&lang=js"
import style0 from "./OrganisationMembersTable.vue?vue&type=style&index=0&id=f8a1e5bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a1e5bc",
  null
  
)

export default component.exports